import { BaseComponent } from "utils/base-component"
import "./flag.scss"

const images = require.context("./static", true, /\.svg$/)

type Config = {
  iso?: string
  size?: number
}

export class CountryFlag extends BaseComponent<Config> {
  static cssClass = "flag"

  private flag!: HTMLImageElement

  init() {
    this.flag = document.createElement("img")
    this.flag.classList.add(this.elementClassName("square"))
    if (this.config.iso) this.updateIso(this.config.iso)
    this.updateSize(this.config.size || 24)
    this.root.appendChild(this.flag)
  }

  updateIso(iso: string) {
    this.flag.src = images(`./square/${iso.toLowerCase()}.svg`)
  }

  updateSize(size: number) {
    this.flag.width = size
    this.flag.height = size
  }
}
